import React from 'react';
import Person from './cards/person';
import Event from './cards/event';

const Attended = ({ topNode, bottomNode, data, topRelation, bottomRelation }) => {
  if (!bottomRelation) bottomRelation = topRelation;
  return (
    <>
      <Person properties={topNode} headerText={topRelation} />
      <Event properties={{ ...bottomNode, registrationDate: data?.registrationDate }} headerText={bottomRelation} />
    </>
  );
};

export default Attended;
